import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function Contacts(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      width={width || "24"}
      height={height || "16"}
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0)">
        <path
          d="M8.4 8C9.23068 8 10.0427 7.76541 10.7334 7.32588C11.4241 6.88635 11.9624 6.26164 12.2803 5.53074C12.5982 4.79983 12.6814 3.99556 12.5193 3.21964C12.3572 2.44372 11.9572 1.73098 11.3698 1.17157C10.7825 0.612165 10.0341 0.231202 9.21938 0.0768607C8.40466 -0.0774802 7.56018 0.00173313 6.79273 0.304484C6.02528 0.607234 5.36933 1.11992 4.90783 1.77772C4.44633 2.43552 4.2 3.20888 4.2 4C4.2 5.06087 4.6425 6.07828 5.43015 6.82843C6.2178 7.57857 7.28609 8 8.4 8ZM8.4 2.28572C8.75601 2.28572 9.10402 2.38626 9.40003 2.57463C9.69603 2.76299 9.92675 3.03073 10.063 3.34397C10.1992 3.65722 10.2349 4.0019 10.1654 4.33444C10.096 4.66698 9.92453 4.97244 9.67279 5.21218C9.42106 5.45193 9.10033 5.6152 8.75116 5.68135C8.402 5.74749 8.04008 5.71355 7.71117 5.5838C7.38226 5.45405 7.10114 5.23432 6.90336 4.95241C6.70557 4.67049 6.6 4.33906 6.6 4C6.6 3.54535 6.78964 3.10931 7.12721 2.78782C7.46477 2.46633 7.92261 2.28572 8.4 2.28572ZM8.46 13.7143H3.324C4.91228 12.9962 6.64225 12.6067 8.4 12.5714C8.532 12.5714 8.676 12.5829 8.808 12.5829C9.25529 11.7364 9.93548 11.0214 10.776 10.5143C9.99223 10.3741 9.19737 10.2976 8.4 10.2857C5.592 10.2857 0 11.6229 0 14.2857V16H8.4V14.2857C8.40154 14.0939 8.42162 13.9026 8.46 13.7143ZM17.4 10.8571C15.192 10.8571 10.8 12.0114 10.8 14.2857V16H24V14.2857C24 12.0114 19.608 10.8571 17.4 10.8571ZM18.852 8.77715C19.434 8.47056 19.8926 7.98845 20.1556 7.40661C20.4185 6.82478 20.471 6.17621 20.3048 5.56286C20.1386 4.94951 19.763 4.40617 19.2372 4.01824C18.7114 3.63032 18.0651 3.41981 17.4 3.41981C16.7349 3.41981 16.0886 3.63032 15.5628 4.01824C15.037 4.40617 14.6614 4.94951 14.4952 5.56286C14.329 6.17621 14.3815 6.82478 14.6445 7.40661C14.9074 7.98845 15.366 8.47056 15.948 8.77715C16.3906 9.0168 16.8909 9.1428 17.4 9.1428C17.9091 9.1428 18.4094 9.0168 18.852 8.77715Z"
          fill={color || "#bbb"}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="16" fill={color || "#bbb"} />
        </clipPath>
      </defs>
    </svg>
  );
}
